import { Component, DOCUMENT, Inject, TemplateRef, ViewChild } from '@angular/core';
import { HireSidebarComponent } from '../hire-sidebar/hire-sidebar.component';
import { LocalStorageService } from '../_services/local-storage.service';
import { CandidateService } from '../_services/candidate.service';
import { HireSkeletonLoadersComponent } from '../hire-person-search/hire-skeleton-loaders/hire-skeleton-loaders.component';
import { HireCandidateCardComponent } from '../hire-person-search/hire-candidate-card/hire-candidate-card.component';
import { NgbDropdownModule, NgbModal, NgbOffcanvas, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { HireSliderComponent } from '../hire-person-search/hire-candidate-slider/hire-slider/hire-slider.component';
import { EmailCampaignService } from '../email-campaign/email-campaign.service';
import { CampaignService } from '../_services/campaign.service';
import { CandidateSelectionService } from '../projects/services/candidate-selection.service';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { AddToPipelineComponent } from '../hire-person-search/add-to-pipeline/add-to-pipeline.component';
import { AddToCampaignComponent } from '../hire-person-search/add-to-campaign/add-to-campaign.component';
import { HireSearchService } from '../hire-person-search/services/hire-search.service';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { PipelineFilterStoreService } from '../projects/services/pipeline-filter-store.service';
import { PipelineFilterComponent } from '../projects/pipeline-filter/pipeline-filter.component';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ActivatedRoute } from '@angular/router';
import { BulkRevealModalComponent } from '../bulk-reveal-modal/bulk-reveal-modal.component';

@Component({
  selector: 'app-my-candidates',
  imports: [HireSidebarComponent, HireSkeletonLoadersComponent, HireCandidateCardComponent, NgbPaginationModule, NgbDropdownModule, AddToPipelineComponent, AddToCampaignComponent, ReactiveFormsModule, FormsModule, CommonModule, MatAutocompleteModule],
  templateUrl: './my-candidates.component.html',
  styleUrl: './my-candidates.component.scss',
})
export class MyCandidatesComponent {

  selectedCandidates: any[] = [];
  calledFrom: string = 'my-candidates';
  selectedCandidateIds: Set<string> = new Set();
  showTalentCount: number = 0;
  totalCandidatesCount: number = 0;
  selectAllChecked: boolean = false;
  currentPage: number = 1;
  start: number = 1;
  end: number = 20;
  allCandidates: any[] = [];
  showProjectCandidateListLoader: boolean = false;
  campaignList: any[] = [];
  selectionSub: Subscription;
  subscriptions: Subscription[] = [];
  successMessage: string = '';
  errorMessage: string = '';
  infoMessage: string = '';
  projectList: any[] = [];
  sorttype: string = 'new';
  pipelineFilterCount: number = 0;
  searchInput: UntypedFormControl = new UntypedFormControl(null);
filterPayload: any = {};
candidateNameRes: any[] = [];
searchFilterPayload: any = {};
private typeAheadSubject = new Subject<{ event: Event }>();
search: string | null = null;

  @ViewChild('bulkRevealScopeModal') bulkRevealScopeModal!: TemplateRef<any>;


  constructor (private localStorage: LocalStorageService, private candidateService: CandidateService, private offcanvasService: NgbOffcanvas, private emailCampaignService: CampaignService,
    @Inject(DOCUMENT) private document: Document, private candidateSelectionService: CandidateSelectionService, private hireSearchService: HireSearchService, private pipelineFilterStore: PipelineFilterStoreService,
    private modalService: NgbModal, private activatedRoute: ActivatedRoute
  ){

  }

  ngOnInit() {
    this.search = this.activatedRoute.snapshot.queryParamMap.get("search");
    if(this.search) {
      this.searchInput.setValue(this.search);
      this.selectOption(this.search, 'enter');
    }
    this.selectionSub = this.candidateSelectionService.selectedIds$
      .subscribe(ids => this.selectedCandidateIds = ids);
    this.subscriptions.push(this.selectionSub);

    const pipelineFilterCountSub = this.pipelineFilterStore.filterPayload$
      .subscribe(payload => {
        this.onModalFilterChange({ payload, isReset: false })
        this.pipelineFilterCount = payload?.filtercount || 0;
      });
    this.subscriptions.push(pipelineFilterCountSub);

        const typeaheadSub = this.typeAheadSubject
          .pipe(debounceTime(500))
          .subscribe(({ event }) => this.callTypeAheadSearch(event));

        this.subscriptions.push(typeaheadSub);

    this.getAllCandidates();
    this.fetchProjectList();
    this.getCampaignList();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  openFilterModal(){
  const modalRef =   this.modalService.open(PipelineFilterComponent, { windowClass: 'hireProjectFilterModal', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.searchCandidates = this.searchFilterPayload?.searchedcandidates || [];

  }

  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

  onStageUpdated(event) {
    this.candidateSelectionService.triggerReload();
    const checked = false; // Reset the select all checkbox when stage is updated
    this.candidateSelectionService.setSelectAll(checked);
    // selectAllChecked itself gets set by the selectionSub above, but set it
    // immediately too so the checkbox doesn't visually lag.
    this.selectAllChecked = checked;
  }

  selectAll(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.candidateSelectionService.setSelectAll(checked);
    const selectedCandidates = checked ? this.candidateSelectionService.getSelectedCandidates() : [];
    // this.uploadCandidateService.setCandidateSelectedData(selectedCandidates);
    // selectAllChecked itself gets set by the selectionSub above, but set it
    // immediately too so the checkbox doesn't visually lag.
    this.selectAllChecked = checked;
  }

  fetchProjectList(): void {
    this.hireSearchService.getProjectTypeahead('').subscribe((response: any) => {
      if (response.success == true) {
        this.projectList = response.data;
      }
    });
  }

  get selectedCandidateIdsArray(): string[] {
    console.log("Selected Candidate Ids: ",this.selectedCandidateIds);
    return Array.from(this.selectedCandidateIds);
  }

  getAllCandidates(){
    this.showProjectCandidateListLoader = true;
    const payload = {
      usernumber: this.localStorage.getItem('usernumber'),
      resultsize: "20",
      sortby: this.sorttype,
      startingfrom: this.start == 1 ? 0 : this.start,
      pipelinestatus: "'Hot', 'Warm', 'Cold'",
      ...this.filterPayload,
      ...this.searchFilterPayload
    }
    this.candidateService.getCandidateList(payload).subscribe((res: any) => {
      console.log(res);
      this.showProjectCandidateListLoader = false;
      if(res.status === 'success'){
        this.allCandidates = res.data.candidatedetails;
        this.allCandidates = this.allCandidates.map((candidate: any) => ({
          ...candidate,
          id: candidate.basicdetails.candidatenumber,
          experience: (candidate.experienceDetails || []).map(this.mapExperience),
          full_name_with_middle_name: [
            candidate.basicdetails.firstname,
            candidate.basicdetails.middlename,
            candidate.basicdetails.lastname
          ].filter(Boolean)
            .join(' '),
          location_name: (candidate.basicdetails.locationname || []),
          industry: (candidate.basicdetails.industryname || null),
          totaltenure: candidate.basicdetails.totalexperience,
          linkedin_url: candidate.basicdetails.profileurl,
          candidatenumber: candidate.basicdetails.candidatenumber,

        }));
        this.candidateSelectionService.setCandidates(this.allCandidates);
        this.totalCandidatesCount = res.data.allcandidatescount;
      }
    });
  }

  get selectedCandidatesFull(): any[] {
    return this.candidateSelectionService.getSelectedCandidates();
  }

  private mapExperience(exp: any) {
    return {
      company: {
        name: exp.companyname,

        location: {
          name: exp.locationname,

        },

        website: exp.website
      },
      location_names: exp.locationname ? [exp.locationname] : [],
      end_date: exp.enddate,
      start_date: exp.startdate,
      title: {
        name: exp.jobtitle,

      },
      is_primary: exp.iscurrent === 1,
      summary: exp.workdescription,

    };
  }

  handleChildEvent(event: { action: string, data: any, index: number | null }) {
      if (event.action === 'stage-updated') {
        // Candidate's pipeline stage changed - re-fetch this page so the card reflects it.
        this.getAllCandidates();
        return;
      }

      const offcanvasRef = this.offcanvasService.open(HireSliderComponent, {
        position: 'end',
        backdrop: true,
        panelClass: 'ngb-candidate-slider'
      });

      // Pass data to component
      offcanvasRef.componentInstance.title = 'My Sidebar';
      offcanvasRef.componentInstance.candidateinfo = event.data;
      offcanvasRef.componentInstance.candidatelist = [...this.allCandidates]; // clone - don't share ref with store
      offcanvasRef.componentInstance.currentIndex = event.index;
      offcanvasRef.componentInstance.totalCount = this.totalCandidatesCount;
      offcanvasRef.componentInstance.calledFrom = 'my-candidates';
      offcanvasRef.componentInstance.campaignList = this.campaignList;
      offcanvasRef.componentInstance.candidateUpdated.subscribe((updatedData: any) => {
      const id = updatedData?.candidatenumber;
      if (!id) return;
      this.allCandidates = this.allCandidates.map(c =>
        c.id === id ? { ...c, ...updatedData } : c
      );
    });
    }

    getCampaignList() {
      this.emailCampaignService.getCampaigns({ campaign_name: '', created_by: this.localStorage.getItem('userdata').userid, 'status[]': [1, 2] }).subscribe((data) => {
        this.campaignList = data['data'];
      });
    }

    setPage(index: number) {
      let start = (index - 1) * 20;
      this.start = start;
      this.end = this.start + 20;
      if (this.end > this.totalCandidatesCount) {
        this.end = this.totalCandidatesCount;
      }
      this.selectAllChecked = false;
      this.candidateSelectionService.setSelectAll(false);
      this.getAllCandidates();
      this.document.documentElement.scrollTop = 0;
    }

    /**
   * Handle radio button filter for candidate listing
   * @param event
   */
  onFilterChange(event: any) {
    this.sorttype = event.target.value;
    this.getAllCandidates();
  }

    onSelectionChange(event: { id: string, checked: boolean }) {
      this.candidateSelectionService.toggleCandidate(event.id, event.checked);
    }

  /**
   * "Bulk Reveal Contact" for My Candidates - same two scopes and the same eligibility check as the
   * other listings (CandidateSelectionService): Selected and Current page. The numbers next to each
   * option (already revealed / pending) are fetched once when the popup opens.
   */
  revealPreview: { selected: { eligible: any[]; alreadyRevealed: any[]; pending: any[] } | null; currentPage: { eligible: any[]; alreadyRevealed: any[]; pending: any[] } | null } =
    { selected: null, currentPage: null };
  loadingRevealPreview: { selected: boolean; currentPage: boolean } = { selected: false, currentPage: false };

  openBulkRevealScopeModal(): void {
    this.modalService.open(this.bulkRevealScopeModal, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });

    this.revealPreview = { selected: null, currentPage: null };
    this.loadingRevealPreview = { selected: true, currentPage: true };

    // Selected is always a subset of the current page (the selection is cleared on page change),
    // so the reveal status is fetched once for their union instead of once per option.
    const idOf = (c: any) => this.candidateSelectionService.resolveElasticId(c);
    const currentPageCandidates = this.allCandidates;
    const selectedCandidates = this.candidateSelectionService.getSelectedCandidates();
    const unionMap = new Map<string, any>();
    [...currentPageCandidates, ...selectedCandidates].forEach(c => unionMap.set(idOf(c), c));

    this.candidateSelectionService.fetchRevealStatusById([...unionMap.values()], idOf).subscribe(byId => {
      this.revealPreview.currentPage = this.candidateSelectionService.computeRevealEligibility(currentPageCandidates, byId, idOf);
      this.revealPreview.selected = this.candidateSelectionService.computeRevealEligibility(selectedCandidates, byId, idOf);
      this.loadingRevealPreview = { selected: false, currentPage: false };
    }, () => {
      this.loadingRevealPreview = { selected: false, currentPage: false };
      this.errorMessage = 'Could not check the reveal status of these candidates. Please try again.';
    });
  }

  dismissBulkRevealScopeModal(): void {
    this.modalService.dismissAll();
  }

  revealScope(scope: 'selected' | 'currentPage'): void {
    const preview = this.revealPreview[scope];
    if (!preview) return; // still loading - the option is disabled in the template until ready

    this.dismissBulkRevealScopeModal();
    const eligibleCandidatePayload = preview.eligible.map((c: any) => ({
      elastic_id: this.candidateSelectionService.resolveElasticId(c),
      candidatenumber: c?.basicdetails?.candidatenumber || c?.candidatenumber || c?.id
    }));

    const modalRef = this.modalService.open(BulkRevealModalComponent, { size: 'xs' as 'lg', centered: true, windowClass: 'modalemailcampaign' });
    modalRef.componentInstance.calledFor = 'listing-bulk-reveal';
    modalRef.componentInstance.eligibleCandidatePayload = eligibleCandidatePayload;
    modalRef.componentInstance.enrichedFromOverride = 'my-candidates';

    modalRef.componentInstance.bulkRevealModalData.subscribe((result: any) => {
      if (result?.status === 'success') {
        this.candidateSelectionService.markRevealSubmitted(eligibleCandidatePayload.map(c => c.elastic_id));
        // selection only - clear() would also wipe the just-submitted markers set on the line above
        this.candidateSelectionService.setSelectAll(false);
        this.candidateSelectionService.notifyRevealSubmitted();
        this.selectAllChecked = false;
      }
    });
  }

    onModalFilterChange(event: { payload: any, isReset: boolean }) {
   this.filterPayload = event?.payload || {};
    this.currentPage = 1;
    this.start = 1;
    this.end = 20;
    this.getAllCandidates();

    }

    onSearchInput(event) {
      this.typeAheadSubject.next({ event });
    }

    callTypeAheadSearch(event) {
      const data = {};
      if(event.target.value == ''){
        this.searchFilterPayload = {};
        this.getAllCandidates();
        return;
      }
      data['candidatenamepayload'] = event.target.value;
      this.candidateService.getCandidateNameTypeahead(data).subscribe((res : any) => {
        this.candidateNameRes = res;
      });
    }

    selectOption(value: any, type?: string) {
      if(type === 'enter'){

        const parts = value.trim().split(' ').filter(Boolean); // filter(Boolean) removes extra spaces


        this.searchFilterPayload['searchedcandidates'] = [
          { firstname: parts[0] || null,
            middlename: parts.length === 3 ? parts[1] : null,
            lastname: parts.length === 3 ? parts[2] : (parts.length === 2 ? parts[1] : null) }
        ];
      this.searchInput.setValue(value);

      } else {
     this.searchInput.setValue(value.fullname);
      this.searchFilterPayload['searchedcandidates'] = [
        { firstname: value.firstname,
          middlename: value.middlename,
          lastname: value.lastname }
      ];
      }


      this.candidateNameRes = [];
        this.currentPage = 1;
    this.start = 1;
    this.end = 20;
      this.getAllCandidates();
    }
}
